// Construire l'URL directe du document sur le serveur
function buildDirectProofUrl(documentPath) {
  if (!documentPath) return null;
  // Le chemin est stocké comme "preuve/tasks/filename.pdf"
  // On construit l'URL complète vers fhcgroupesarl.com (domaine principal)
  return `https://fhcgroupesarl.com/plateforme/${documentPath}`;
}

export default function PreuvesPanel({ tasks = [], employes = [] }) {
  const tachesAvecPreuve = tasks.filter(t => t.done && t.document_preuve);
  
  // ✅ return null conditionnel APRÈS tous les hooks
  if (!tachesAvecPreuve.length) return null;

  const getEmpNom = (task) => {
    const emp = employes.find(e => e.user_id === task.employee_id || e.id === task.employee_id);
    return emp?.nom || task.employee?.nom || task.employee?.prenom || '—';
  };

  return (
    <>
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">
          📎 Documents de preuve soumis
          <span className="card-badge">{tachesAvecPreuve.length}</span>
        </div>
        <table className="tbl">
          <thead>
            <tr>
              <th>Tâche</th>
              <th>Employé</th>
              <th>Validée le</th>
              <th>Fichier</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tachesAvecPreuve.map(t => {
              const fileName = t.document_preuve.split('/').pop();
              const ext = fileName.split('.').pop().toLowerCase();
              const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
              const isPdf = ext === 'pdf';
              return (
                <tr key={t.id}>
                  <td className="bold">{t.text || t.titre}</td>
                  <td>{getEmpNom(t)}</td>
                  <td style={{ fontSize: 11, color: '#889' }}>
                    {t.completed_at ? new Date(t.completed_at).toLocaleDateString('fr-FR') : '—'}
                  </td>
                  <td>
                    <span style={{ fontSize: 11, color: '#C9A84C' }}>
                      {isImage ? '🖼️' : isPdf ? '📄' : '📎'} {fileName}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-outline"
                      style={{ padding: '4px 10px', fontSize: 11 }}
                      onClick={() => {
                        const documentUrl = buildDirectProofUrl(t.document_preuve);
                        console.log('🔍 Version NOUVELLE - Ouverture directe:', documentUrl);
                        if (documentUrl) {
                          window.open(documentUrl, '_blank');
                        }
                      }}
                    >
                      👁️ Voir
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>


    </>
  );
}